var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2fvgv79w6a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360 0v640H0V0h360z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bj445mruob"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.96 24.32h5.12a2.56 2.56 0 1 1-5.12 0zM11.52 0a2.56 2.56 0 0 1 2.56 2.56v.371a8.947 8.947 0 0 1 6.4 8.589v7.68l2.56 2.56v1.28H0v-1.28l2.56-2.56v-7.68a8.947 8.947 0 0 1 6.4-8.589V2.56A2.56 2.56 0 0 1 11.52 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m41eysh1sc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0v32H0V0h32z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2fvgv79w6a)",
    transform: "translate(-241 -14)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bj445mruob)",
    transform: "translate(246.12 16.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h23.04v26.88H0V0z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m41eysh1sc)",
    transform: "translate(-5.12 -2.56)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.12 2.56h23.04v26.88H5.12V2.56z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/icon-bell.066a9eee712abef8b5be9624a9606857.svg";
export { ForwardRef as ReactComponent };